module.exports = __webpack_public_path__ + "48a1eb83637eb301f4792d8bc3d65010.svg";